export const PageConfig = {
    "thead": {
        "s_no": "S.no",
        "name": "Name",
        "status": "Status",
        "action": "Action"
    },
    "tbody": [
         {
            "s_no": "1",
            "name": "Home",
            "status": "Active"
        },
        {
            "s_no": "2",
            "name": "Guide and FAQ",
            "status": "Active"
        },
        {
            "s_no": "3",
            "name": "Shipping and Delivery",
            "status": "Active"
        },
        {
            "s_no": "4",
            "name": "Privacy Policy",
            "status": "Active"
        },
        {
            "s_no": "5",
            "name": "Terms and Conditions",
            "status": "Active"
        }
    ]
}
